import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';
import { benefits } from '../constants';

const Features: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Por que as Empresas Escolhem Nossos Serviços Tributários
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            No complexo ambiente tributário atual, as empresas frequentemente pagam mais impostos do que o legalmente necessário.
            Nossa expertise ajuda você a identificar e recuperar esses pagamentos em excesso.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl">
            <div className="p-8">
              <div className="flex items-center mb-4">
                <AlertTriangle className="h-8 w-8 text-red-500 mr-3" />
                <h3 className="text-xl font-semibold text-gray-900">O Desafio Tributário</h3>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-red-500 mr-2">❌</span>
                  <p className="text-gray-700"><span className="font-medium">Regulamentações tributárias complexas</span> que mudam frequentemente, dificultando a conformidade</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-red-500 mr-2">❌</span>
                  <p className="text-gray-700"><span className="font-medium">Acesso limitado a especialistas</span> que entendem como identificar oportunidades de recuperação fiscal</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-red-500 mr-2">❌</span>
                  <p className="text-gray-700"><span className="font-medium">Milhares de reais perdidos</span> anualmente através de deduções e créditos não aproveitados</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-red-500 mr-2">❌</span>
                  <p className="text-gray-700"><span className="font-medium">Risco de auditorias e multas</span> por declarações e documentações inadequadas</p>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl">
            <div className="p-8">
              <div className="flex items-center mb-4">
                <CheckCircle className="h-8 w-8 text-green-500 mr-3" />
                <h3 className="text-xl font-semibold text-gray-900">Nossa Solução</h3>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-2">✓</span>
                  <p className="text-gray-700"><span className="font-medium">Recuperação fiscal especializada</span> para identificar e solicitar reembolsos de impostos pagos em excesso</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-2">✓</span>
                  <p className="text-gray-700"><span className="font-medium">Planejamento tributário estratégico</span> para minimizar legalmente obrigações fiscais futuras</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-2">✓</span>
                  <p className="text-gray-700"><span className="font-medium">Gestão abrangente de conformidade</span> para prevenir erros e multas custosas</p>
                </li>
                <li className="flex items-start">
                  <span className="flex-shrink-0 h-6 w-6 text-green-500 mr-2">✓</span>
                  <p className="text-gray-700"><span className="font-medium">Equipe de suporte dedicada</span> com profundo conhecimento em questões tributárias específicas do setor</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {benefits.map((benefit) => (
            <div 
              key={benefit.id}
              className="bg-white p-6 rounded-lg shadow border border-gray-100 hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;